import { makeStyles } from '@material-ui/core/styles';


export default makeStyles(theme => ({
    dialogContent: {
        flex: "1",
        // padding: "20px 10px 10px",
        backgroundColor: "#FFFFFF",
        minWidth: window.isMobileView ? "100%" : "850px",
    },
    gridHeader: {
        padding: "6px 15px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        "& .HeaderDialog": {
            display: "flex",
            alignItems: "center",
            justifyContent: "right",
        },
    },
    gridActions: {
        textAlign: "right",
    },
    GridHeading: {
        color: "var(--accent-colors-ui-1-default, #3C4549)",
        fontFamily: "Lato",
        fontSize: "19.819px",
        fontStyle: "normal",
        fontWeight: "700",
        lineHeight: "normal",
    },


    subHeading: {
        fontFamily: 'Lato',
        fontStyle: "normal",
        fontWeight: 800,
        fontSize: "15px",
        alignItems: "center",
        color: "#4b4b4b",
        display: "flex",
        marginTop: "15px"

    },
    BrowseMain: {
        position: 'relative',
        "& .BrowseButton": {
            position: 'absolute',
            top: '10px',
            right: '10px',
            color: '#424242',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: '700',
            lineHeight: '16px',
            letterSpacing: '0.14px',
        }
    },
    fileInput: {
        paddingRight: '80px !important',
    },
    customLabel: {
        margin: "10px 0px",
        color: "#4b4b4b"
    },
    dialogPaper: {
        minWidth: window.isMobileView ? "100%" : "800px",

    },
    box: {
        display: "flex",
        flexFlow: "column",
        height: "100%",
        // padding: "18px 10px 10px 20px",
        padding: '0px 0px 15px 0px'
    },
    header: {
        background: "#E8E8E8",
        display: "flex",
        alignItems: "center",
        height: "49px",
        padding: "0px 0px 0 15px",
        "& h1": {
            padding: "0px 15px",
            fontSize: "22px",
            fontWeight: 600,
            lineHeight: "28.8px",
            color: "#2D4D95",
        },
    },
    content: {
        flex: "1 1 auto",
        // maxHeight: "580px",
        // overflow: "auto",
        marginBottom: "10px",
        padding: '10px 20px'
    },
    organizationDiscription: {
        fontFamily: "Lato",
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "17px",
        letterSpacing: "0em",
        textAlign: "left",
    },
    cardHeader: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '10px',
        justifyContent: 'space-between',
        borderBottom: '1px solid #F1F1F1',
        backgroundColor: "#DFEEFF",
        padding: '0 10px'
    },
    shippingLayout: {
        "& .custom-label": {
            // marginTop: '10px !important',
        }

    },
    marginTopTwenty: {
        marginTop: '25px',
    },
    cardHeaderTitle: {
        display: "flex",
        alignItems: "center"
    },
    container: {
        padding: '0px 10px'
    },

    footer: {
        flex: "0 1 40px",
        gap: '10px',
        padding: '0 20px'
    },
    footerRight: {
        float: "right",
        marginRight: "-8px",
        display: 'flex',
        gap: '10px'
    },
    notesEditor: {
        "& .RichTextEditor__root___2QXK-": {
            minHeight: window.isMobileView ? '250px' : '160px',
            maxHeight: '160px',
            overflow: 'auto',
        }
    },
    crossButton: {
        position: "relative",
        top: "-12px",
        right: "10px",
        cursor: "pointer",
        padding: "3px",
        zIndex: "2",
        display: "block",
        "& :hover": {
            backgroundColor: "#F4F4F4",
        }
    },
    closeIcon: {
        cursor: 'pointer',
        color: 'white',
    },
    title: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '20px',
        lineHeight: '24px',
        color: '#FFFFFF',
        letterSpacing: '0.02em',
    },
    labelText: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '20px',
        color: '#3C4549',
        padding: "14px 0px 5px",
    },
    valueText: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '20px',
        color: '#3C4549',
        padding: "6px 0",
        textTransform: 'capitalize',
    },
    radioInfo: {
        "& .MuiFormGroup-root": {
            display: 'flex',
            flexDirection: 'row',
        },
        "& .MuiFormControlLabel-label": {
            fontFamily: 'Lato !important',
            fontStyle: 'normal',
            fontSize: '13px',
            fontWeight: 600,
            color: '#4b4b4b',
        },
    },
    backBtn: {
        fontSize: '14px',
        lineHeight: '16px',
        fontWeight: 600,
        color: '#454545',
        borderRadius: '4px',
        padding: '8px 16px',
        textTransform: 'uppercase',
        border: '1px solid #454545',
        cursor: 'pointer',
    },
    changeBtn: {
        fontSize: '14px',
        lineHeight: '16px',
        fontWeight: 600,
        cursor: 'pointer',
        backgroundColor: '#454545',
        borderRadius: '4px',
        marginRight: '5px',
        padding: '8px 16px',
        textTransform: 'uppercase',
        cursor: 'pointer',
        color: '#ffffff',
        margin: '3px 0px',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)',
        '&:hover': {
            color: '#ffffff',
            background: '#5e5e5e',
        }
    },
    secHeading: {
        color: '#4F4F4F',
        fontSize: '16px',
        lineHeight: '12px',
        padding: '12px 6px',
        borderBottom: '1px solid #BBBEBF',
        width: '100%',
        marginBottom: '15px',
        fontFamily: 'Lato',
        fontWeight: 600,
    },
    tabcontainer: {
        background: 'white',
        margin: '10px',
        padding: '10px 13px',
        borderRadius: '15px',
        "& .MuiButton-label": {
            fontWeight: 600,
            fontSize: "12px",
            color: "white",
            // letterSpacing:"0.01rem",
            textTransform: "uppercase"
        },
        "& .MuiTabs-flexContainer": {
            borderBottom: '1px solid #e1e1e1',
        },
        "& .MuiButtonBase-root": {
            color: '#424242',
            textTransform: 'capitalize',
            fontWeight: 600,
        }
    },
    companyCard: {
        padding: "20px",
        border: "1px dashed black",
        borderRadius: "10px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: 'center',
        "& .companyLogo": {
            border: "1px solid black",
            borderRadius: "100%",
            width: "135px",
            height: "135px",
            textAlign: "center",
            "& img": {
                width: '135px',
                height: '135px',
                borderRadius: '90px',
                padding: '5px',
            }
        },

    },
    rightSide: {
        // backgroundColor:"black",
        // border:"1px solid black",
        // borderRadius:"12px",
        // margin:"0px 10px",
        padding: "15px",
        "& .rating": {
            display: "flex",
            alignItems: "center",
            gap: "5px"
        },

        "& .frame": {
            display: "flex",
            alignItems: "flex-start",
            gap: "10px",
            fontWeight: 600,
            margin: "15px 0px",
            color: "rgba(60, 69, 73, 0.8)",

            "& img": {
                marginTop: '4px'
            }
        }
    },
    contactInfo: {
        display: "flex",
        gap: "20px",
        alignItems: "center"
    },

    contactInfoFrame: {
        display: "flex",
        gap: "40px"
    },
    frame: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        fontWeight: 600,
        margin: "15px 0px",
        color: "rgba(60, 69, 73, 0.8)",
    },
    selectBaseInput: {
        width: '100%',
        display: 'flex',
        boxSizing: 'border-box',
        margin: '5px 0px 5px',
        backgroundColor: 'white',
        minHeight: '35.63px',
        padding: '0px 8px 0px 12px',
        height: '35.63px',
        opacity: '0.7',
        border: '0.5px solid #777D80',
        borderRadius: '4px',



        "& .MuiInputBase-input": {
            padding: "0px 24px 0px 12px",
            minHeight: "35.63px",
            fontSize: "14px",
            color: "#4A4A4A",
            '&:focus': {
                background: 'transparent',
                borderRadius: "4px",
                outline: 0,
            },
            "&:before": {
                borderBottom: 'none !important',
            },
        },
        "& .MuiInput-underline:before": {
            borderBottom: 'none'
        },

        "& .Mui-disabled": {
            backgroundColor: "#f3f3f3",
            color: "#4A4A4A"
        },
        "& input::-webkit-outer-spin-button": {
            appearance: "none",
            margin: 0
        },
        "& input::-webkit-inner-spin-button": {
            appearance: "none",
            margin: 0
        },
        "& input[type=number]": {
            appearance: "textfield"
        },
    },
}));